import React from 'react';
import styled from 'styled-components';
import FormattedText from 'components/FormattedText';
import { blockPadV, blockW } from 'theme/mixins/padding';
import type { AboutHero as T } from './types';
import TinaResponsiveAsset from 'components/TinaResponsiveAsset';

const Wrapper = styled.div`
  ${() => blockPadV()};
`;

const Container = styled.div`
  ${() => blockW()};
  width: 100%;
  // 71px is height of navbar
  height: calc(100vh - 71px);
  position: relative;
  // overflow: hidden;
`;

const Content = styled.div`
  position: absolute;
  text-align: center;
  width: 80%;
  margin: 0 auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${({ theme }) => theme.mq.sm`
    width: 50%;
  `}
  ${({ theme }) => theme.mq.lg`
    width: 70%;
  `}
`;

const SFormattedText = styled(FormattedText)`
  ${({ theme }) => theme.mq.mdOnly`
    font-size: 2.5rem;
  `}
`;

const StyledResponsiveAsset = styled(TinaResponsiveAsset)`
  object-position: center;
  object-fit: contain;
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const AboutHero: React.FC<T> = ({ sublead, backgroundImg }) => {
  return (
    <Wrapper>
      <Container>
        <StyledResponsiveAsset asset={backgroundImg} />
        <Content>
          <SFormattedText pFormat={'sansRegular52'} forwardedAs="h1">
            {sublead}
          </SFormattedText>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default AboutHero;
